module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Consignee Master")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [(_vm.$sessionsStorage.get('designation') == 'Admin' && _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh') ? _c('b-nav-form', [_c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.addEditCardFunc()
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export as Excel' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReportsAss('All_Consignee_Report', 'Export as Excel')
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName) + "\n              "), (_vm.ExcelBtnName != 'Export as Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.addEditCard) ? _c('b-card', {
    staticClass: "gutr"
  }, [_c('b-row', {
    staticClass: "align-items-end"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.ConsigneeMaster.agentName) + " Consignee Details")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Consignee Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.categoryTypeList,
      "option-value": "categoryTypeVal",
      "option-text": "categoryTypeTxt",
      "isDisabled": ""
    },
    model: {
      value: (_vm.ConsigneeMaster.categoryType),
      callback: function($$v) {
        _vm.$set(_vm.ConsigneeMaster, "categoryType", $$v)
      },
      expression: "ConsigneeMaster.categoryType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Consignee Name\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "agentName",
      "name": "agentName",
      "placeholder": "Consignee Name"
    },
    model: {
      value: (_vm.ConsigneeMaster.agentName),
      callback: function($$v) {
        _vm.$set(_vm.ConsigneeMaster, "agentName", $$v)
      },
      expression: "ConsigneeMaster.agentName"
    }
  }), _vm._v(" "), (!_vm.ConsigneeMaster.agentName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.agentName) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Contact No. "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "contactNumber",
      "name": "contactNumber",
      "placeholder": "Contact Number"
    },
    model: {
      value: (_vm.ConsigneeMaster.contactNumber),
      callback: function($$v) {
        _vm.$set(_vm.ConsigneeMaster, "contactNumber", $$v)
      },
      expression: "ConsigneeMaster.contactNumber"
    }
  }), _vm._v(" "), (!_vm.ConsigneeMaster.contactNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.contactNumber) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Status :")]), _vm._v(" "), _c('md-switch', {
    staticClass: "md-primary",
    attrs: {
      "id": 'approval' + _vm.ConsigneeMaster.isACActive,
      "name": "approval",
      "value": _vm.ConsigneeMaster.isACActive == 1 ? true : false
    },
    on: {
      "change": function($event) {
        _vm.activateconsigneeMaster()
      }
    }
  }, [_c('h6', [_c('b-badge', {
    attrs: {
      "variant": _vm.ConsigneeMaster.isACActive == 1 ? 'success' : 'danger'
    }
  }, [_vm._v(_vm._s(_vm.ConsigneeMaster.isACActive == 1 ? "Active" : "In-Active"))])], 1)])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Email "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "emailId",
      "name": "emailId",
      "placeholder": "Email"
    },
    model: {
      value: (_vm.ConsigneeMaster.emailId),
      callback: function($$v) {
        _vm.$set(_vm.ConsigneeMaster, "emailId", $$v)
      },
      expression: "ConsigneeMaster.emailId"
    }
  }), _vm._v(" "), (!_vm.ConsigneeMaster.emailId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.emailId) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Company Name "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "companyName",
      "name": "companyName",
      "placeholder": "Company Name"
    },
    model: {
      value: (_vm.ConsigneeMaster.companyName),
      callback: function($$v) {
        _vm.$set(_vm.ConsigneeMaster, "companyName", $$v)
      },
      expression: "ConsigneeMaster.companyName"
    }
  }), _vm._v(" "), (!_vm.ConsigneeMaster.companyName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.companyName) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("Address "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "address",
      "name": "address"
    },
    model: {
      value: (_vm.ConsigneeMaster.address),
      callback: function($$v) {
        _vm.$set(_vm.ConsigneeMaster, "address", $$v)
      },
      expression: "ConsigneeMaster.address"
    }
  }), _vm._v(" "), (!_vm.ConsigneeMaster.address) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.address) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('center', [_c('b-button', {
    staticClass: "mt-2",
    staticStyle: {
      "margin-bottom": "0.3rem"
    },
    attrs: {
      "variant": "success",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addConsigneeMaster
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.consigneeMaster.agntColoaderId ? "Update" : "Save") + "\n                  ")])], 1), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Consignee Master and Code"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.StatusTypeList,
      "option-value": "StatusTypeVal",
      "option-text": "StatusTypeTxt",
      "placeholder": "Select Status"
    },
    on: {
      "input": _vm.getAllConsigneeMasterList
    },
    model: {
      value: (_vm.Status),
      callback: function($$v) {
        _vm.Status = $$v
      },
      expression: "Status"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.All_Consignee_List_data,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection,
      "responsive": "",
      "primary-key": "stateId"
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "agntColoader",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "categoryType",
      fn: function(row1) {
        return [_c('span', {
          staticClass: "showMoreData",
          on: {
            "click": function($event) {
              _vm.$sessionsStorage.get('designation') == 'Admin' && _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ? _vm.viewEdit(row1.item) : ''
            }
          }
        }, [_vm._v(_vm._s(row1.item.categoryType))])]
      }
    }, {
      key: "agentName",
      fn: function(row11) {
        return [_c('span', [_vm._v(_vm._s((row11.item.agentName != '') ? row11.item.agentName : '--'))])]
      }
    }, {
      key: "contactNumber",
      fn: function(row13) {
        return [_c('span', [_vm._v("\n                    Contact No. : " + _vm._s(row13.item.contactNumber) + "\n                    "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                    Email : " + _vm._s(row13.item.emailId) + "\n                    "), _c('br')])]
      }
    }, {
      key: "bl_no",
      fn: function(row14) {
        return [_c('span', [_vm._v(" " + _vm._s(row14.item.bl_no) + " ")])]
      }
    }, {
      key: "bl_date",
      fn: function(row15) {
        return [_c('span', [_vm._v(" " + _vm._s(row15.item.bl_date) + " ")])]
      }
    }, {
      key: "creationTime",
      fn: function(row16) {
        return [_c('span', [_vm._v("\n                    Created at: "), _c('br'), _vm._v(" " + _vm._s(row16.item.creationTime) + "\n                    "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                    Created by: "), _c('br'), _vm._v(" " + _vm._s(row16.item.createdBy) + "\n                    "), _c('br')])]
      }
    }, {
      key: "updateTime",
      fn: function(row17) {
        return [_c('span', [_vm._v("\n                    Updated at: "), _c('br'), _vm._v(" " + _vm._s(row17.item.updateTime) + "\n                    "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                    Updated by: "), _c('br'), _vm._v(" " + _vm._s(row17.item.UpdatedBy) + "\n                    "), _c('br')])]
      }
    }, {
      key: "isACActive",
      fn: function(row22) {
        return [(_vm.adminToggle == 'Admin') ? _c('div', {
          attrs: {
            "id": 'row' + row22.item.agntColoaderId
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row22.item.agntColoaderId,
            "name": "approval",
            "value": row22.item.isACActive == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateConsigneeUser(row22.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row22.item.isACActive == 1 ? 'Active' : 'In-Active'))])], 1)])], 1) : _c('div', {
          attrs: {
            "id": 'row' + row22.item.agntColoaderId
          }
        }, [_c('h6', [_c('b-badge', [_vm._v(_vm._s(row22.item.isACActive == 1 ? 'Active' : 'In-Active'))])], 1)])]
      }
    }, {
      key: "action",
      fn: function(row2) {
        return [_c('b-button', {
          attrs: {
            "variant": "outline-primary",
            "id": "addButtonLoader",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.editConsigneeMaster(row2.item)
            }
          }
        }, [_vm._v("Update")])]
      }
    }, {
      key: "companyName",
      fn: function(row14) {
        return [_c('span', [_vm._v("\n                    Company Name : " + _vm._s(row14.item.companyName) + "\n                    "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                    Address : " + _vm._s(row14.item.address) + "\n                    "), _c('br')])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "25",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-674a000e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/masters/consigneeMaster.vue
// module id = 2701
// module chunks = 0